import { Trans } from '@lingui/macro';
import * as React from 'react';

export const inputNationalRegisterErrorMessage = (
  <Trans>
    Ce champ doit posséder un numéro de registre national valide
  </Trans>
);
